import React from 'react';
import { motion } from 'framer-motion';
import { Users, UserCheck, Award } from 'lucide-react';
export function Slide5DualOpportunity() {
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-644">
      <div className="mb-8 border-b border-slate-100 pb-6" data-id="element-645">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-646">
          05 / Dual Opportunity
        </div>
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-2" data-id="element-647">
          Market Research Opportunity
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-648">
          Individual response data enables precision targeting for both
          acquisition and retention.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 flex-1 items-stretch [&>*]:flex [&>*]:flex-col" data-id="element-649">
        {/* New Customers */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm" data-id="element-650">
          <div className="flex items-center gap-3 mb-4" data-id="element-651">
            <div className="p-2.5 bg-emerald-50 rounded-xl" data-id="element-652">
              <Users className="w-5 h-5 text-emerald-600" data-id="element-653" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-654">
              For New Customer Acquisition
            </h3>
          </div>

          <div className="bg-slate-50 p-5 rounded-xl border border-slate-100" data-id="element-655">
            <ul className="text-sm text-slate-700 space-y-3 font-medium list-disc pl-5 marker:text-emerald-400" data-id="element-656">
              <li data-id="element-657">
                12 leads — a mix of net-new prospects and existing
                prospects/customers
              </li>
              <li data-id="element-658">Development stage and bottlenecks identified per lead</li>
              <li data-id="element-659">Personalized outreach enabled for higher conversion</li>
            </ul>
          </div>
        </motion.div>

        {/* Existing Base */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm" data-id="element-660">
          <div className="flex items-center gap-3 mb-4" data-id="element-661">
            <div className="p-2.5 bg-blue-50 rounded-xl" data-id="element-662">
              <UserCheck className="w-5 h-5 text-blue-600" data-id="element-663" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-664">
              For Existing Customer Expansion
            </h3>
          </div>

          <div className="bg-slate-50 p-5 rounded-xl border border-slate-100" data-id="element-665">
            <ul className="text-sm text-slate-700 space-y-3 font-medium list-disc pl-5 marker:text-blue-400" data-id="element-666">
              <li data-id="element-667">
                Identify perception gaps to proactively address churn risk
              </li>
              <li data-id="element-668">Tailor service offerings to address stated bottlenecks</li>
              <li data-id="element-669">Increase wallet share through new study initiation</li>
            </ul>
          </div>
        </motion.div>
      </div>

      {/* Competitive Advantages */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="bg-minerva-dark rounded-2xl p-5 border border-minerva-blue/20 text-white flex items-center gap-5" data-id="element-670">
        <div className="p-3 bg-white/10 rounded-full shrink-0" data-id="element-671">
          <Award className="w-6 h-6 text-minerva-cyan" data-id="element-672" />
        </div>
        <div data-id="element-673">
          <h4 className="text-lg font-bold text-minerva-cyan mb-1" data-id="element-674">
            Competitive Advantage: Exclusive Intelligence
          </h4>
          <p className="text-white/90 text-sm" data-id="element-675">
            Minerva is the only company with this data, enabling a data-driven
            sales narrative and validating our market leadership position.
          </p>
        </div>
      </motion.div>
    </div>;
}